// prettier-ignore
const radixColorScalesRegular = ['tomato', 'red', 'ruby', 'crimson', 'pink', 'plum', 'purple', 'violet', 'iris', 'indigo', 'blue', 'cyan', 'teal', 'jade', 'green', 'grass', 'brown', 'orange'];
const radixColorScalesBright = ['sky', 'mint', 'lime', 'yellow', 'amber'];
const radixColorScalesMetal = ['gold', 'bronze'];
// prettier-ignore
const radixColorScales = [...radixColorScalesRegular, ...radixColorScalesBright, ...radixColorScalesMetal];
const radixGrayScalePure = 'gray';
const radixGrayScalesDesaturated = ['mauve', 'slate', 'sage', 'olive', 'sand'];
const radixGrayScales = [radixGrayScalePure, ...radixGrayScalesDesaturated];
function radixGetMatchingGrayScale(colorScale) {
    switch (colorScale) {
        case 'tomato':
        case 'red':
        case 'ruby':
        case 'crimson':
        case 'pink':
        case 'plum':
        case 'purple':
        case 'violet':
            return 'mauve';
        case 'iris':
        case 'indigo':
        case 'blue':
        case 'sky':
        case 'cyan':
            return 'slate';
        case 'teal':
        case 'jade':
        case 'mint':
        case 'green':
            return 'sage';
        case 'grass':
        case 'lime':
            return 'olive';
        case 'yellow':
        case 'amber':
        case 'orange':
        case 'brown':
        case 'gold':
        case 'bronze':
            return 'sand';
    }
}
export { radixColorScalesRegular, radixColorScalesBright, radixColorScalesMetal, radixColorScales, 
//
radixGrayScalePure, radixGrayScalesDesaturated, radixGrayScales, 
//
radixGetMatchingGrayScale, };
//# sourceMappingURL=radix-colors.js.map